import { validator } from "LIB/validate-this";
import {
  BUYER,
  BUYING_LIMIT,
  COMMISSION_CREDIT_PERCENT,
  EMAIL,
  FIRST_NAME,
  LAST_NAME,
  ROLE,
  SALES,
  TEAM_LEADER_CREDIT_PERCENT,
  TEAM_MEMBERS,
  USER_ID
} from "MODULES/users/constants";
import * as rules from "LIB/validation/rules";
import { LOCATION_ID } from "MODULES/Locations/constants";

function validateItem(item) {
  item.validate(USER_ID, TEAM_LEADER_CREDIT_PERCENT).required();
}

export default function validate(values, props) {
  return validator(values, v => {
    v
      .validate(FIRST_NAME, LAST_NAME, EMAIL, ROLE, LOCATION_ID)
      .satisfies(rules.required);
    v.validate(EMAIL).satisfies(rules.isValidEmail);

    v.validate(BUYING_LIMIT).satisfies(rules.requiredAllowZero);

    if ([BUYER, SALES].includes(props.values.role)) {
      v
        .validate(COMMISSION_CREDIT_PERCENT)
        .satisfies(
          rules.requiredAllowZero,
          rules.isGreaterThanOrEqualTo(0),
          rules.isLessThanOrEqualTo(100)
        );
    }

    v.validateChildren(TEAM_MEMBERS, validateItem);
  });
}



// WEBPACK FOOTER //
// ./app/modules/users/components/EditUser/validate.js